import { cva } from 'class-variance-authority';
export const inlineMessageVariants = cva('inline-message', {
    variants: {
        variant: {
            default: 'inline-message-default',
            success: 'inline-message-success',
            primary: 'inline-message-primary',
            warn: 'inline-message-warn',
            danger: 'inline-message-danger',
            base: 'inline-message-base',
            epic: 'inline-message-epic',
            alert: 'inline-message-alert',
            brand: 'inline-message-brand',
        },
    },
    defaultVariants: {
        variant: 'base',
    },
});
//# sourceMappingURL=variants.js.map